import { Adhese, AdheseAd, createAdhese } from "@adhese/sdk";

declare global {
  interface Window {
    adhese?: Adhese<never[]>;
    mobileLayout: string;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const printButton = document.querySelector(
    ".form__btn-pdf"
  ) as HTMLButtonElement;

  window.mobileLayout = "web";
  document.documentElement.classList.add(window.mobileLayout);

  printButton.addEventListener("click", () => {
    window.print();
  });

  // mailButton.addEventListener("click", () => {
  //   const subject = `Bekijk hier de ad preview voor: ${window.orderName} - ${window.creativeName}`;
  //   const body = `Hoi, ${"%0D%0A %0D%0A"} Bekijk hier de ad preview. ${"%0D%0A"} Campaign naam: ${window.orderName} ${"%0D%0A"} Creative naam: ${window.creativeName} ${"%0D%0A %0D%0A"} Bekijk de preview hier: ${encodeURIComponent(window.location.href)} ${"%0D%0A %0D%0A"} Met vriendelijke groet,`;
  //   const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${body}`;
  //   window.location = mailtoLink;
  // });

  function renderTemplate(template: string, values: Record<string, string>) {
    return template.replace(/\[([^\]]+)\]/g, (_, key) => values[key] ?? "");
  }

  function processUrl(input: string): string {
    return input.replace(
      /\[(.*?)\](.*?)\[(.*?)\]/g,
      (_, _prefix, toEncode, _suffix) => {
        return encodeURIComponent(toEncode);
      }
    );
  }

  function createImage(ad: AdheseAd) {
    const shotImagePresent = ad.tag?.visual.shortImage.variants[0].url
      ? "covershort-present"
      : "";
    const internalButton = `<button class="icon-button_root icon-button_primary icon-button_neutral icon-button_small"
                            type="button" aria-label="Pistachio color" tabindex="-1" aria-hidden="true" data-iconbutton="true"> 
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16" width="16" fill="currentColor">
                                  <path d="M5.32 3.293a1.163 1.163 0 0 1 1.543 0L12 8l-5.137 4.707c-.426.39-1.117.39-1.543 0a.942.942 0 0 1 0-1.414L8.913 8 5.32 4.707a.942.942 0 0 1 0-1.414"></path>
                              </svg> 
                          </button>`;
    const externalButton = `<button class="icon-button_root icon-button_primary icon-button_neutral icon-button_small" 
                            type="button" aria-label="Bekijk de deal" tabindex="-1" aria-hidden="true" data-iconbutton="true">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16" width="16" fill="currentColor">
                                  <path d="M2 3a1 1 0 0 1 1-1h2.3a1 1 0 0 1 0 2H4v8h8v-1.4a1 1 0 1 1 2 0V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"></path><path d="M8.3 3a1 1 0 0 1 1-1H13a1 1 0 0 1 1 1v3.6a1 1 0 1 1-2 0V5.329L7.81 9.603a1 1 0 1 1-1.42-1.406L10.5 4H9.3a1 1 0 0 1-1-1"></path>
                                </svg>
                            </button>`;
    const coverImage = `<div class="spotlight-cover-image_root" data-cover-image="true"> 
                      <img class="image_root image_fill spotlight-cover-image_shortImage" src="${ad.tag?.visual.shortImage.variants[0].url}"
                    alt="${ad.tag?.visual.shortImage.description}"> 
                      <img class="image_root image_fill spotlight-cover-image_image ${shotImagePresent}"
                            src="${ad.tag?.visual.longImage.variants[0].url}" alt="${ad.tag?.visual.longImage.description}" loading="lazy"> 
                      </div>`;

    const videoImage = `<div class="spotlight-image_root spotlight-banner_image" style="width:100%; height:100%"> <video width="100%" height="100%" class="spotlight-video" muted autoplay>
                            <source src="${ad.tag?.visual?.video?.videoData?.assets?.src}" type="video/mp4">
                        </video><img class="image_root image_fill thumbnail-img" src="${ad.tag?.visual?.video?.videoData?.thumbnails?.src}">  </div>`;

    const packshotImage = `<div class="spotlight-packshot-image_root spotlight-packshot-image_packshot-${ad.tag?.visual.theme}" data-packshot-image="true"> 
                        <img class="image_root image_fit" src="${ad.tag?.visual.image.variants[0].url}" alt="${ad.tag?.visual.image.description}"> 
                        </div>`;
    const stickerImage = `<div class="spotlight-image_sticker spotlight-image_sticker-desktop"> 
                      <img class="image_root image_fit" src="${ad.tag?.sticker.variants[0].url}" alt="${ad.tag?.sticker.description}">
                    </div>`;
    const htmlCode = `<div data-testhook="spotlight-ahrms-slot" class="spotlight-container_banner spotlight-container_full">
        <div data-slot="1_1" id="slot-R9tb" style="height:100%" data-name="ah_website_nl_home_1_1-flex"
            data-status="rendered" data-format="flex"> <a href="[link]" target="_blank" class="spotlight-banner_root">
                <div class="spotlight-image_root spotlight-banner_image">[image][sticker]</div>
                <div class="spotlight-body_root">
                    <div class="spotlight-body_textContainer">
                        <h3 class="typography_typography typography_heading-3-desktop typography_align-left"> ${ad.tag?.title}</h3>
                        <p class="typography_typography typography_body-regular-desktop typography_align-left"> ${ad.tag?.subtitle}</p>
                    </div>
                    <div class="spotlight-body_buttonContainer"> [clickOutButton] </div>
                </div>
            </a> </div>
    </div>`;

    const values = {
      clickOutButton: ad.tag.link.href.includes("www.ah.nl")
        ? internalButton
        : externalButton,
      sticker: ad.tag?.sticker.variants[0].url !== "" ? stickerImage : "",
      image:
        ad.tag?.visual?.renderType === "PACKSHOT"
          ? packshotImage
          : ad.tag?.visual?.renderType === "VIDEO"
            ? videoImage
            : coverImage,
      coverShortPresent: shotImagePresent,
      link: !ad.slotName.includes("1_4")
        ? decodeURIComponent(
            `${ad.clickTag?.href}/${processUrl(ad.tag.link.href.split("UR")[1])}`
          )
        : "#",
      appLink: ad.slotName.includes("1_2") ? appLink : "",
    };

    return renderTemplate(htmlCode, values);
  }

  function processAd(ad: AdheseAd) {
    if (typeof ad.tag !== 'object') {
      return { ...ad, renderMode: 'iframe' as const };
    }
    console.log("ad", ad);
    let appLink = `https://ah.nl${window.location.search}`;
    let webLink = `https://ah.nl${window.location.search}`;
    let webLanding = `https://ah.nl${window.location.search}`;
    let renderType = ad.tag.visual.renderType;

    if (ad.tag.type === "Spotlight") {
      const appLinkElem = document.getElementById("appLink");
      const webLinkElem = document.getElementById("webLink");
      const webLandingElem = document.getElementById("webLanding");
      const toastEl = document.querySelector(".toast");
      const renderTypeElem = document.getElementById("renderType");

      if (renderTypeElem && (renderType === "" || renderType === "PACKSHOT")) {
        toastEl.style.display = "flex"; 

        renderTypeElem.innerText = renderType;

        if (renderType == "") {
          renderTypeElem.innerText = "None" 
        }
      }

      if (webLinkElem) {
        webLinkElem.innerHTML = `
          <a href="${webLink}" target="_blank">Link naar ah.nl</a>`;
      }

      webLanding = decodeURIComponent(
        `${ad.clickTag?.href}/${processUrl(ad.tag.link.href.split("UR")[1])}`
      );

      if (webLandingElem && webLanding != "") {
        webLandingElem.innerHTML = `
          <a href="${webLanding}" target="_blank">Web landing link</a>`;
      } else {
        document
          .querySelector(".web-landing .label")
          ?.classList.add("is-hidden");
      }

      appLink = decodeURIComponent(processUrl(ad.tag?.link.mobileLink));

      if (appLinkElem && appLink != "") {
        appLinkElem.innerHTML = `
          <a href="${appLink}" target="_blank">${appLink}</a>`;

        if (document.getElementById("qrcode")?.children.length <= 0) {
          const qrcode = new QRCode(document.getElementById("qrcode"), {
            text: appLink,
            width: 175,
            height: 175,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.Q,
          });
        }
      } else {
        document
          .querySelector(".qr-wrapper .label")
          ?.classList.add("is-hidden");
      }

      return {
        ...ad,
        tag: createImage(ad),
      };
    }
    return ad;
  }

  const getPreview = (previewHost: string, host: string) => {
    window.adhese = createAdhese({
      account: "ahms",
      host: host,
      previewHost: previewHost,
      debug: true,
      consent: true,
     //eagerRendering: true,
      initialSlots: [
        {
          format: "flex",
          containingElement: "web_preview",
          slot: "1_1",
          width: "100%",
          height: "100%",
          renderMode: "inline",
          setup(context, { onBeforeRender, onRender }) {
            (onBeforeRender(processAd),
              onRender(() => {
                if (document.querySelectorAll(".spotlight-video") !== null) {
                  document
                    .querySelectorAll(".spotlight-video")
                    .forEach((video) => {
                      video.addEventListener("ended", () => {
                        document
                          .querySelectorAll(".spotlight-video")
                          .forEach((video) => {
                            video.style.display = "none";
                          });
                        document
                          .querySelectorAll(".thumbnail-img")
                          .forEach((thumbnail) => {
                            thumbnail.style.display = "block";
                          });
                      });
                    });
                }
              }));
          },
        },
        {
          format: "flex",
          containingElement: "app_preview",
          slot: "1_4",
          width: "100%",
          height: "100%",
          renderMode: "inline",
          setup(context, { onBeforeRender }) {
            onBeforeRender(processAd);
          },
        },
      ],
      location: `ah_website_nl_home_`,
    });
  };

  const queryParams = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  let previewHost: string;
  let host: string;

  switch (queryParams.site) {
    case "aholdtest":
      previewHost = "https://aholdtest-preview.adhese.org";
      host = "https://ads-aholdtest.adhese.com";
      break;
    case "ahold":
      previewHost = "https://ahold-preview.adhese.org";
      host = "https://ads-ahold.adhese.com";
      break;
    case "hamster":
      previewHost = "https://hamster-preview.staging-adhese.org";
      host = "https://ads-hamster.adhese.com";
      break;
    default:
      previewHost = "https://ahms-preview.adhese.org";
      host = "https://ads-ahms.adhese.com";
      break;
  }
  getPreview(previewHost, host);
});
